import moment from 'moment';

import 'moment/locale/fr';

const configureMoment = () => {
  moment.locale('fr');
};

export default configureMoment;
